export const timeData = [
  {
    timeValue: '1',
    time: '1시',
  },
  {
    timeValue: '2',
    time: '2시',
  },
  {
    timeValue: '3',
    time: '3시',
  },
  {
    timeValue: '4',
    time: '4시',
  },
  {
    timeValue: '5',
    time: '5시',
  },
  {
    timeValue: '6',
    time: '6시',
  },
  {
    timeValue: '7',
    time: '7시',
  },
  {
    timeValue: '8',
    time: '8시',
  },
  {
    timeValue: '9',
    time: '9시',
  },
  {
    timeValue: '10',
    time: '10시',
  },
  {
    timeValue: '11',
    time: '11시',
  },
  {
    timeValue: '12',
    time: '12시',
  },
  {
    timeValue: '13',
    time: '13시',
  },
  {
    timeValue: '14',
    time: '14시',
  },
  {
    timeValue: '15',
    time: '15시',
  },
  {
    timeValue: '16',
    time: '16시',
  },
  {
    timeValue: '17',
    time: '17시',
  },
  {
    timeValue: '18',
    time: '18시',
  },
  {
    timeValue: '19',
    time: '19시',
  },
  {
    timeValue: '20',
    time: '20시',
  },
  {
    timeValue: '21',
    time: '21시',
  },
  {
    timeValue: '22',
    time: '22시',
  },
  {
    timeValue: '23',
    time: '23시',
  },
  {
    timeValue: '24',
    time: '24시',
  },
];
